/* 22 okt (theme C only): compact desktop header while scrolling (styles in akb-header.css).
   adds the class akb-hdr-compact to the header section from 990 px wide once the page is scrolled past the full
   header, and removes it again near the top (with a margin, so it does not flicker). the full heights are measured
   before compacting and kept on <body>, so the page keeps exactly the same layout; only the fixed bar at the top gets
   lower. the state is always read from the page itself, so it recovers if the theme re-renders or resets the header. */
(() => {
  if (window.akbHeaderInstalled) return;
  window.akbHeaderInstalled = true;
  const body = document.body;
  const mq = window.matchMedia('(min-width: 990px)');
  const secEl = () => document.querySelector('.header-section.sticky-header');
  const isOn = (sec) => sec.classList.contains('akb-hdr-compact');
  const measure = (sec) => {
    if (isOn(sec)) return;
    const hdr = sec.querySelector('.site-header');
    const full = sec.getBoundingClientRect().height, site = hdr ? hdr.getBoundingClientRect().height : 0;
    if (full > 0) body.style.setProperty('--akb-hdr-full', full + 'px');
    if (site > 0) body.style.setProperty('--akb-hdr-site', site + 'px');
  };
  const set = (sec, v) => {
    if (v === isOn(sec)) return;
    if (v) measure(sec);
    sec.classList.toggle('akb-hdr-compact', v);
    if (v) { const hdr = sec.querySelector('.site-header'); const c = hdr ? hdr.getBoundingClientRect().height : 0; if (c > 0) body.style.setProperty('--akb-hdr-c', c + 'px'); }
  };
  const update = () => {
    const sec = secEl(); if (!sec) return;
    if (!mq.matches) { set(sec, false); return; }
    const full = parseFloat(body.style.getPropertyValue('--akb-hdr-full')) || 170;
    const y = window.scrollY;
    if (!isOn(sec) && y > full + 90) set(sec, true);
    else if (isOn(sec) && y < full - 10) set(sec, false);
  };
  let raf = 0;
  const onScroll = () => { if (!raf) raf = requestAnimationFrame(() => { raf = 0; update(); }); };
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', () => { const sec = secEl(); if (!sec) return; set(sec, false); measure(sec); update(); });
  if (mq.addEventListener) mq.addEventListener('change', update);
  const sec0 = secEl(); if (sec0) measure(sec0);
  update();
})();

/* 26 okt (theme C only): newsletter popup once per visitor per period.
   the theme re-opened the popup on every page view (seen on a phone and reproduced on desktop). once it has been
   shown, it stays hidden on this device for the theme's own popup period (data-popup-time, in days; default 7).
   uses browser storage; if storage is blocked the theme's own behaviour applies. test mode is left alone. */
(() => {
  if (window.akbPopupOnce) return;
  window.akbPopupOnce = true;
  const p = document.getElementById('popup');
  if (!p || p.getAttribute('data-popup-test-mode') === 'true') return;
  const K = 'akb-popup-seen';
  const days = parseInt(p.getAttribute('data-popup-time'), 10) || 7;
  let seen = 0;
  try { seen = Number(localStorage.getItem(K)) || 0; } catch (e) { return; }
  if (seen && Date.now() - seen < days * 864e5) {
    const st = document.createElement('style');
    st.textContent = '#popup,#slide-up,#popup .desktop-popup,#PopupOverlay{display:none!important}';
    document.head.appendChild(st);
    return;
  }
  const mark = () => { try { localStorage.setItem(K, String(Date.now())); } catch (e) { /* */ } };
  // the theme opens it by adding the class "visible" to #popup and showing #slide-up (mobile/desktop) or #fullscreen
  const su = document.getElementById('slide-up'), fs = document.getElementById('fullscreen');
  const shown = () => p.classList.contains('visible') || (su && su.style.visibility === 'visible') || (fs && fs.style.display && fs.style.display !== 'none');
  const obs = new MutationObserver(() => { if (shown()) { mark(); obs.disconnect(); } });
  [p, su, fs].filter(Boolean).forEach((el) => obs.observe(el, { attributes: true, attributeFilter: ['style', 'class'] }));
  p.addEventListener('submit', mark, true);
})();
